import React from 'react';
import {Box, Typography} from '@mui/material';

export const EmptyStateNoChat = () => (
    <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        color: 'text.secondary'
    }}>
        <Typography variant="body2">Select a chat or start a new one</Typography>
    </Box>
);

export const EmptyStateNoMessages = () => (
    <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        color: 'text.secondary'
    }}>
        <Typography variant="body2">No messages yet. Start the conversation!</Typography>
    </Box>
);

